import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import {
  DriverLocation, RecordLocationInput,
  recordLocation, getLiveLocations, listMyLocations, listForDriver,
} from '../services/driverLocationsApi';

interface LocationsState {
  live: DriverLocation[];
  history: DriverLocation[];
  loading: boolean;
  error: string | null;
  fetchLive: (staleMinutes?: number) => Promise<void>;
  fetchMyHistory: (limit?: number) => Promise<void>;
  fetchForDriver: (driverId: number, limit?: number) => Promise<void>;
  record: (input: RecordLocationInput) => Promise<DriverLocation>;
}

const toErr = (e: unknown) => (e instanceof Error ? e.message : 'Something went wrong');

export const useDriverLocationsStore = create<LocationsState>()(
  devtools(
    (set) => ({
      live: [],
      history: [],
      loading: false,
      error: null,
      fetchLive: async (staleMinutes) => {
        set({ loading: true, error: null });
        try { set({ live: await getLiveLocations(staleMinutes), loading: false }); }
        catch (err) { set({ loading: false, error: toErr(err) }); }
      },
      fetchMyHistory: async (limit) => {
        try { set({ history: await listMyLocations(limit) }); }
        catch (err) { set({ error: toErr(err) }); }
      },
      fetchForDriver: async (driverId, limit) => {
        try { set({ history: await listForDriver(driverId, limit) }); }
        catch (err) { set({ error: toErr(err) }); }
      },
      record: async (input) => {
        return await recordLocation(input);
      },
    }),
    { name: 'driver-locations-store' }
  )
);
